import React, { Component } from "react";
import {
  Row,
  Col,
  Progress,
  Card,
  CardBody,
  CardHeader,
  Table,
  Form,
  FormGroup,
  Label,
  Button,
  Input
} from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
//import FR from 'date-fns/locale/FR';
import "react-datepicker/dist/react-datepicker.css";

//import { Row, Col, Card, CardBody, CardGroup } from "reactstrap";
import AuthService from "../../components/AuthService";
//import { List } from "react-content-loader";
//const MyListLoader = () => <List />;


class TagsFilters extends Component {
  constructor(props) {
    super(props);

    let startDateTemp = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
    //startDateTemp.setMonth(date.getMonth() – 12);

    this.Auth = new AuthService();
    this.state = {
      tagsList: [],
      startDate: '', // createdAt company RH + liste des entreprises
      endDate: new Date(),
      startDateMysql : '',
      endDateMysql : ''
    };
    this.selectedTags = [];


    this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

//  pour le click sur les périodes // on passe le bind direct pour envoyer des params, donc plus besoin ici.
//    this.setPeriod = this.setPeriod.bind(this);

    this.profile = this.Auth.getProfile();
  }

    componentDidMount() {
        this.fetchTagsData(this);
        this.fetchDataCompanyDetails(this, (this.props.id ? this.props.id : null));
    }

    fetchTagsData(thus) {
        this.Auth.httpRequest("GET", "api/dashboard/selectTagsByCompanyId").then(
          function(datas) {
            thus.setState(previousState => ({
              tagsList: datas.data
            }));
          }
        );
    }

    fetchDataCompanyDetails(thus, idCompany){
        //console.log('id company ou pas ? ', idCompany);


        if(!idCompany) {
        //  console.log('pas d id company, récuperation selon le profil connecté');
            return this.Auth.getCompanyDetails(this.profile.sub)
              .then(
                  datas => {
                      //console.log("datas dans tagsfilters", datas);
                      thus.setState({startDate: new Date(datas.createdAtUnix*1000)});
                  }
              )
              .catch(error => console.log(error));
        } else {
            //console.log('changement de requete ici!!!');

            this.Auth.httpRequest("GET", "api/company/selectCompanyDetailsById?companyId=" + idCompany).then(
              function(datas) {
                //console.log("datas dans tagsfilters avec un id company", datas.data[0]);
                thus.setState({startDate: new Date(datas.data[0].createdAtUnix*1000)});
              }
            );
        }
    }


//  handle change sur le choix du select des tags
    handleChange(selectedOptions) {
        window.selectedTags = [];
        this.selectedTags = [];
        selectedOptions.forEach(el => {
          window.selectedTags.includes(el.value)
            ? null
            : window.selectedTags.push(el.value);
          this.selectedTags.includes(el) ? null : this.selectedTags.push(el);
        });
        this.forceUpdate();
        this.props.updateData();
    }

    //  récuperation du changement sur la date de début
    handleChangeStartDate(date) {
    //  par défaut on vide le champs de window // @TODO : à virer
        window.startDateMysql = '';
        //console.log('date reçu : ' + date);

    //  on calcul la nouvelle date mysql que si la date est différente de nule
        if(date != null) {
        //  pour prendre en compte le timezeoneOffset (sinon ça met des dates mauvaises j-1)
            let tempDate = date;
            tempDate.setHours(0, -date.getTimezoneOffset(), 0, 0);
            //console.log('on a changé la date de début à ' + tempDate.toISOString().slice(0, 10)+' 00:00:00');
            //console.log('date reçu suite' + date);
            window.startDateMysql = tempDate.toISOString().slice(0, 10)+' 00:00:00' ;
        }

    //  mise à jour de l'état de la date
        this.setState({
            startDate: date
        });
    }

    //  récuperation du changement sur la date
    handleChangeEndDate(date) {
    //  par défaut on vide le champs de window // @TODO : à virer
        window.endDateMysql = '';

        //console.log('on a changé la date de fin à ' + date.toISOString().slice(0, 19).replace('T', ' '));

    //  on calcul la nouvelle date mysql que si la date est différente de nule
        if(date != null) {
            let tempDate = date;
            tempDate.setHours(0, -date.getTimezoneOffset(), 0, 0);
            //console.log('on a changé la date de fin à ' + tempDate.toISOString().slice(0, 10)+ ' 23:59:59');
            window.endDateMysql = tempDate.toISOString().slice(0, 10)+' 00:00:00' ;
        }

    //  mise à jour de l'état de la date
        this.setState({
            endDate: date
        });
    }

    /**
     * Alexandre Vasseur
     * lorsqu'on click sur un des boutons de périodes
     */
    setPeriod(type, event) {
    //  on stop la propagation de l'evenement
        event.preventDefault();
        let periodicity = event.currentTarget.getAttribute("data-period");
        let startDateTemp = new Date();

        switch (periodicity) {
            case "week":
            //  définition de la date à j-7
                startDateTemp.setDate(startDateTemp.getDate() - 7);
                this.setState({
                    startDate: startDateTemp
                });
                break;

            case "month":
            //  définition de la date à j-7
                startDateTemp.setMonth(startDateTemp.getMonth() - 1);
                this.setState({
                    startDate: startDateTemp
                });
                break;

            case "3months":
            //  définition de la date à j-7
                startDateTemp.setMonth(startDateTemp.getMonth() - 3);
                this.setState({
                    startDate: startDateTemp
                });
                break;
            default:
                startDateTemp.setDate(startDateTemp.getDate() - 7);
                this.setState({
                    startDate: startDateTemp
                });
                break;
        }

    //  on force le click pour soumettre le formulaire
        this.handleSubmit(event);
    }

    // Action lorsqu'on a cliquer sur le submit
    // Préparation du tableau formater pour passer la requete à l'API
    handleSubmit(event) {
    //  on stop la soumission du formulaire en réel sinon rechargement de la page.
        event.preventDefault();

        //  on défini l'état en chargement
        this.setState({
          isLoading: true
        });


        console.log("start date " + this.state.startDate);


    //  on reformate pour que ça soit préparer pour mysql.
        if(this.state.endDate != '') {
            let tempEndDate = this.state.endDate;
            tempEndDate.setHours(0, -tempEndDate.getTimezoneOffset(), 0, 0);


            this.state.endDateMysql = tempEndDate.toISOString().slice(0, 10)+ ' 23:59:59';
            window.endDateMysql = this.state.endDateMysql;
        }

        if(this.state.startDate != '') {
            let tempStartDate = this.state.startDate;
            tempStartDate.setHours(0, -tempStartDate.getTimezoneOffset(), 0, 0);

            console.log(tempStartDate.toISOString().slice(0, 10));
            
            this.state.startDateMysql = tempStartDate.toISOString().slice(0, 10)+ ' 00:00:00';
            window.startDateMysql = this.state.startDateMysql;
        }

        //  préparer l'objet bodyRequest
        //console.log(this.state);

    //  on force la mise à jour des components et des tableaux avec un nouveau fetch.
        this.forceUpdate();
        this.props.updateData();
    }

//  affichage des tags
    displayTags() {
        const res = [];
        if (this.state.tagsList && this.state.tagsList.length > 0) {
          this.state.tagsList.forEach(element => {
            res.push({ value: element.tagID, label: element.tagName });
          });
        }
        return res;
    }

//  récuperation des valeurs pour les tags
    getDefaultValue() {
        const res = [];
        if (window.selectedTags) {
          this.state.tagsList.forEach(el => {
            window.selectedTags.includes(el.tagID)
              ? res.push({ value: el.tagID, label: el.tagName })
              : null;
          });
        }
        return res;
    }

//  récuperation des valeurs pour les tags
    getValue() {
        return this.selectedTags;
    }


//  récuperation des valeurs pour la date de départ
    getStartDateDefaultValue() {
        let res = '';
        if (window.startDate) {
            res = window.startDate;
        } else {

        }
        return res;
    }

  render() {
    const selectClassName = this.props.error
      ? "basic-multi-select error"
      : "basic-multi-select";
    return (
      <div id="tagBar">
        <Form onSubmit={this.handleSubmit}>
            <Select
              isMulti
              name="tags"
              value={
                this.selectedTags.length ? this.getValue() : this.getDefaultValue()
              }
              options={this.displayTags()}
              onChange={this.handleChange.bind(this)}
              className={selectClassName}
              classNamePrefix="select"
              placeholder="Choisissez des labels pour affinez votre vue"
            /><br />
            <FormGroup row>
                <Col sm={4}>
                    <Button onClick={this.setPeriod.bind(this, "week")} data-period="week">Cette semaine</Button>
                </Col>
                <Col sm={4}>
                    <Button onClick={this.setPeriod.bind(this, "month")} data-period="month">Ce mois</Button>
                </Col>
                <Col sm={4}>
                    <Button onClick={this.setPeriod.bind(this, "3month")} data-period="3months">Les 3 derniers mois</Button>
                </Col>
            </FormGroup>
            <FormGroup row>
                <Col sm={5}>
                    <Label>Date de début : &nbsp;</Label>
                    <DatePicker
                        placeholderText="Date de début"
                        className = "form-control"
                        dateFormat="dd/MM/yyyy"
                        selected={this.state.startDate}
                        selectsStart
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        onChange={this.handleChangeStartDate}
                        placeholderText="Date de début"
                        isClearable={true}
                    />
                </Col>
                <Col sm={5}>
                    <Label>&nbsp;Date de fin :&nbsp;</Label>
                    <DatePicker
                        placeholderText="Date de fin"
                        dateFormat="dd/MM/yyyy"
                        className = "form-control"
                        selected={this.state.endDate}
                        selectsEnd
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        onChange={this.handleChangeEndDate}
                        minDate={this.state.startDate}
                        placeholderText="Date de fin"
                        isClearable={true}
                    />
                </Col>
                <Col sm={2}>
                    <Button>Envoyer</Button>
                </Col>
            </FormGroup>
          </Form>
      </div>
    );
  }
}

export default TagsFilters;



// WEBPACK FOOTER //
// ./src/views/TagsFilters/TagsFilters.js